import React, { useRef, useEffect, useState } from "react";
import DeviceOrientation, { Orientation } from "react-screen-orientation";
import { useDispatch, useSelector } from "react-redux";
import { documentsActions } from "../../store/actions";
import { useNavigate, useLocation } from "react-router-dom";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import {
  Container,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import {
  UseImage,
  CustomAlertMaterial,
  CustomLoadingOverlay,
  Buttons,
  LinkButton,
  GeoLocationGeneric,
} from "../../components";
// import { useStyles } from './IdentityValidationStyles'
// // import { mainStyles, theme } from '../../styles'
import { identityValFunctions } from "./IdentityValFunctions";
import { useProjectContext } from "../../utils";
import load_documentImg from "../../assets/load_document.svg";
import { useTranslation } from "react-i18next";

let mediaStreamTrack;
export default function IdentityValCamera(props) {
  const matches = useMediaQuery("(max-width:650px)");
  const videoRef = useRef();
  const canvasRef = useRef();
  const theme = useTheme();
  const location = useLocation();
  const classes = {}; //mainStyles.bodyStyles()
  const localStyles = {}; //useStyles()
  const context = useProjectContext();

  const [loadView, setLoadView] = useState(false);
  const [photoTaken, setPhotoTaken] = useState(false);
  const [showButtonHideOverlay, setShowButtonHideOverlay] = useState(false);
  const [continueProcess, setContinueProcess] = useState(false);
  const [orientation, setOrientation] = useState(null);
  const [frontPhoto, setFrontPhoto] = useState(null);
  const [document, setDocument] = useState("");
  const [latitude, setLatitude] = useState("-85.05112878");
  const [longitude, setLongitude] = useState("-180");
  const [continueSection, setContinueSection] = useState(false);
  // const [sections, setSections] = useState([])
  // const [docName, setDocName] = useState("")

  const folioId = location.state.folioId;
  const sectionId = location.state.sectionId;
  const sectionName = location.state.sectionName;
  const actorId = location.state.actorId;
  const activeFacialVerification = location.state.activeFacialVerification;
  const activeGeolocation = location.state.activeGeolocation;
  const docTypeId = location.state.docTypeId;
  const docName = location.state.docName;
  const sections = location.state.sections;
  const ext = ".jpg";

  const uploadSecDoc = useSelector((state) => state.UploadSections);
  const uploadDoc = useSelector((state) => state.UploadDocuments);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  let prepareBase64 = (photo) => {
    let base64 = photo;
    base64 = base64.split(",");
    return base64[1];
  };

  useEffect(() => {
    // console.log(" location.state--  Camera Val...------: ", location.state)
    // setSections(location.state.sections)
    // setDocName(location.state.docName)
  }, []); //It doesn't have [] because only affects the orientation Change

  useEffect(() => {
    window.addEventListener("orientationchange", () => {
      setOrientation(window.screen.orientation.type);
    });
  }, [window.screen.orientation.type]); //It doesn't have [] because only affects the orientation Change

  let getVideo = () => {
    let constraints = {
      audio: false,
      video: {
        facingMode: "environment",
        frameRate: { ideal: 13 },
        aspectRatio: 1.777777778,
        width: { min: 1280 },
        height: { min: 720 },
      },
    };

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        videoRef.current.srcObject = stream;
        videoRef.current.play();
        mediaStreamTrack = stream;
      })
      .catch((error) => {
        if (error.message == "Permission denied") {
          console.error(error);
          alert(
            `Es necesario otorgar permisos de cámara para continuar: ${error.message}`
          );
        } else {
          alert(`Error en cámara: ${error.message}`);
        }
        getVideo();
      });
  };

  useEffect(() => {
    getVideo();
    setTimeout(() => {
      setShowButtonHideOverlay(true);
    }, 4000);
  }, [photoTaken, orientation]);

  useEffect(() => {
    if (photoTaken) {
      canvasRef.current.setAttribute("width", videoRef.current.videoWidth);
      canvasRef.current.setAttribute("height", videoRef.current.videoHeight);
      const context = canvasRef.current.getContext("2d");
      context.drawImage(
        videoRef.current,
        0,
        0,
        videoRef.current.videoWidth,
        videoRef.current.videoHeight
      );

      if (!frontPhoto) {
        setFrontPhoto(canvasRef.current.toDataURL("image/png"));
        setDocument(prepareBase64(canvasRef.current.toDataURL("image/png")));
      }
    }
  }, [photoTaken]);

  function handleClick() {
    if (photoTaken) {
      if (frontPhoto != null) {
        const dataforMetadata = {
          File_id: folioId,
          Carga: {
            Referencia: folioId.toString(),
            TransactionId:
              localStorage.getItem("TransactionId") == "null"
                ? null
                : localStorage.getItem("TransactionId"),
            EsBolqueFin:
              docName != "INE / IFE"
                ? true
                : context.sequences == 0 && context.sequences < 2
                ? false
                : context.sequences > 0 && context.sequences >= 2
                ? false
                : true,
            TipoDocumento: docName,
            Seccion: sectionName,
            Imagenes: [
              {
                B64: document,
                Extension: ext,
              },
            ],
            Metadatos: null,
          },
        };
        // console.log("Change camara-----Anverso----Reverso---:  ", dataforMetadata)
        dispatch(documentsActions.CargaDocumento(dataforMetadata));
        setLoadView(true);
      }
    }
    setPhotoTaken(true);
  }

  useEffect(() => {
    if (
      uploadDoc.items != undefined &&
      uploadDoc.items?.TransactionId != null &&
      loadView
    ) {
      const dataToSend = {
        B64Content: document,
        FileId: folioId,
        Actor_Id: actorId,
        SkipActor: null,
        SectionId: sectionId,
        Extension: ".jpg",
        Skip: false,
        SkipReason: null,
        Metadata: null, //Metadata is always null for this lego, the meta would be send in  RegisterIdentityData2
        ContinueWorkFlow: false, //to upload all files before moving
        Geolocation: {
          Latitude: latitude,
          Longitude: longitude,
        }, //Pending
        DeferLoad: false, // heavy file, true to load on backgroud
      };
      // console.log("Request upload doc: carga Section: ---------------- ", dataToSend)
      dispatch(documentsActions.CargaSeccion(dataToSend));
      setContinueProcess(true);
      // console.log("localStorage.getItem('TransactionId')--------Captura camara-----: ", localStorage.getItem('TransactionId'))
      if (
        localStorage.getItem("TransactionId") == "null" ||
        localStorage.getItem("TransactionId") === null
      ) {
        // console.log("Entro llenado de 'TransactionId'------Captura camara-----: ", uploadDoc.items.TransactionId)
        localStorage.setItem("TransactionId", uploadDoc.items.TransactionId); //Almacenar TransactionId
        // context.setTransId(uploadDoc.items.TransactionId)
      }
      //Se modifico comentando la lines 204 /30032022
      setLoadView(false);
      setContinueSection(true);
      context.setSequences(context.sequences + 1);
    }
    if (uploadDoc.error != undefined && loadView) {
      setLoadView(false);
      alert(uploadDoc.error);
    }
  }, [uploadDoc]);

  useEffect(() => {
    if (uploadSecDoc.items != undefined && loadView) {
      if (
        uploadSecDoc.items.Result?.Id != null ||
        uploadSecDoc.items.Result?.Id != undefined
      ) {
        // setLoadView(false)
        // setContinueSection(true)
        // context.setSequences(context.sequences + 1)
      }
    }
    if (uploadSecDoc.error != undefined && loadView) {
      // alert(uploadSecDoc.error)
      // setLoadView(false)
    }
  }, [uploadSecDoc]);

  const backToIdValidation = () => {
    if (videoRef.current) {
      videoRef.current = null;
      videoRef.current?.dispose();
    }
    mediaStreamTrack.stop();
    const nextComponent = "IdentityValidationComponent";
    const secCapture = true;
    const sectionName = sections?.find((item) => item.Name == "Reverso")?.Name;
    console.log(
      "******************************Cambio de componente 1***********IdentityValidationComponent*******************: nextComponent, secCapture, sections, docName, docTypeId : ",
      nextComponent,
      secCapture,
      sections,
      docName,
      docTypeId
    );

    identityValFunctions.nextIndocLoading({
      navigate,
      folioId,
      nextComponent,
      secCapture,
      sections,
      docName,
      docTypeId,
      sectionName,
    });
  };

  useEffect(() => {
    // console.log("context.sequences Validate: ------- ", docName, " - ", continueSection, " - ", context.sequences)
    if (docName != "INE / IFE" && continueSection) {
      // console.log("Continua NO ine: ------- ", docName, " - ", continueSection)
      backToIdValidation();
    } else if (context.sequences > 0 && continueProcess) {
      backToIdValidation();
    }
  }, [context.sequences]);

  const cancelPhoto = () => {
    if (videoRef.current) {
      videoRef.current = null;
      videoRef.current?.dispose();
    }
    mediaStreamTrack.stop();
    if (context.sequences > 0) {
      backToIdValidation();
    } else {
      const nextComponent = "IdentityValidationComponent";
      identityValFunctions.nextIndocLoading({
        navigate,
        folioId,
        nextComponent,
        docTypeId,
      });
    }
  };

  return (
    <div>
      <DeviceOrientation lockOrientation={"landscape"}>
        {activeGeolocation && (
          <GeoLocationGeneric
            SuccessFN={(latitude, longitude) => {
              console.log("succes,latitude, longitude ", latitude, longitude);
              setLatitude(latitude);
              setLongitude(longitude);
            }}
            ErrorFN={(error) => console.log("error", error)}
          />
        )}
        <Orientation orientation="landscape" alwaysRender={false}>
          {loadView && (
            <CustomLoadingOverlay
              active={loadView}
              text={t("general_loading_message")}
            />
          )}
          <div
            className={
              photoTaken && frontPhoto
                ? localStyles.photoContainer
                : localStyles.videoContainer
            }
          >
            <video
              className={localStyles.video}
              ref={videoRef}
              hidden={photoTaken}
            ></video>
            {photoTaken && frontPhoto && (
              <img
                className={localStyles.img}
                src={frontPhoto}
                alt="experiment"
              />
            )}
            <canvas ref={canvasRef} hidden></canvas>
            <div className={localStyles.overlayContainer}>
              {!showButtonHideOverlay && (
                <div className={localStyles.insideTextTip}>
                  <UseImage
                    className={localStyles.docIcon}
                    src={load_documentImg}
                  />
                  <Typography
                    variant={matches ? "subtitle1" : "h6"}
                    style={{ color: "white", marginTop: "10px" }}
                  >
                    Enfoca el <b>documento</b> y presiona el botón para capturar
                    la foto.
                  </Typography>
                </div>
              )}

              {showButtonHideOverlay && photoTaken && (
                <div className={localStyles.approvalSection}>
                  <IconButton
                    classes={{ root: localStyles.iconApproval }}
                    onClick={() => {
                      setPhotoTaken(false);
                      setShowButtonHideOverlay(false);
                      setFrontPhoto(null);
                    }}
                  >
                    <ClearIcon
                      style={{
                        color: "#ffffff",
                        width: "25px",
                        height: "25px",
                      }}
                    />
                  </IconButton>
                  <IconButton
                    classes={{ root: localStyles.iconApproval }}
                    onClick={handleClick}
                  >
                    <CheckIcon
                      style={{
                        color: "#ffffff",
                        width: "25px",
                        height: "25px",
                      }}
                    />
                  </IconButton>
                </div>
              )}
              {!photoTaken && ( // showButtonHideOverlay &&
                <div className={localStyles.sectionToCapture}>
                  <LinkButton
                    LinkButtonText="name button"
                    LinkButtonUrl=""
                    text_size={15}
                    text_color="#ffffff"
                    text={t("general_cancel")}
                    type="button"
                    click={cancelPhoto}
                  />
                  <IconButton
                    classes={{ root: localStyles.iconButton }}
                    onClick={handleClick}
                  >
                    <PhotoCameraIcon
                      style={{
                        color: theme.palette.primary.main,
                        backgroundColor: "#ffffff",
                        width: "25px",
                        height: "25px",
                      }}
                    />
                  </IconButton>
                </div>
              )}
            </div>
          </div>
        </Orientation>

        <Orientation orientation="portrait" alwaysRender={false}>
          <Container>
            <Typography variant="h5" align="center">
              Please rotate your device
            </Typography>
          </Container>
        </Orientation>
      </DeviceOrientation>
    </div>
  );
}
